// extracted by mini-css-extract-plugin
export var errorText = "StudioNameValidator-module__errorText___UDvTR";
export var responseText = "StudioNameValidator-module__responseText___IYLxW";
export var validatorColumn = "StudioNameValidator-module__validatorColumn___vHwA8";
export var validatorRow = "StudioNameValidator-module__validatorRow___a+sZP";